import { useEffect, useReducer } from "react";

export function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

// HH:MM:SS.000 포맷을 넣으면 초 숫자로 변경하여 반환
export function getTimeStringValue( a:string ){
  let a_scalar = 0;
  const a_value = a.split(":")
  a_scalar += (60*60) * parseInt(a_value[0]);
  a_scalar += (60) * parseInt(a_value[1]);
  a_scalar += parseFloat(a_value[2]);
  if( a_scalar==0) return 999999999;
  return a_scalar;
}

export function getTimeString( totalSeconds:number ) {
  // if( totalSeconds > 316800) totalSeconds = 0;
  // 밀리초 추출 (총 초에서 소수점 이하 부분)
  const ms_ = (totalSeconds*1000 % 1000)*0.001; // 소수점 오차를 줄이기위한 방법
  const ms = Math.floor(ms_ * 1000);
  const s = Math.floor(totalSeconds);

  const hh = Math.floor(s / 3600);
  const mm = Math.floor((s % 3600) / 60);
  const ss = s % 60;

  // 0 채우기 (HH, MM, SS는 2자리, ms는 3자리)
  const formattedHh = String(hh).padStart(2, '0');
  const formattedMm = String(mm).padStart(2, '0');
  const formattedSs = String(ss).padStart(2, '0');
  const formattedMs = String(ms).padStart(3, '0');

  return `${formattedHh}:${formattedMm}:${formattedSs}.${formattedMs}`;
}

// 기록 표시 문자열을 숫자로 환산우 두개를 비교하여 a가 크면 true b가 크면 false을 반환
export function compareTimeString( a:string, b:string ){
  
  const a_scalar = getTimeStringValue(a);
  const b_scalar = getTimeStringValue(b);
  
  if( a_scalar==0) return 999999999;
  if( b_scalar==0) return -999999999;
  return a_scalar-b_scalar;
}

export function getDateString( format:string, date:Date ){
  const year = date.getFullYear().toString();
    // Month is 0-indexed, so add 1
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    let formattedDate = format;
    formattedDate = formattedDate.replace(/yyyy/g, year);
    formattedDate = formattedDate.replace(/MM/g, month);
    formattedDate = formattedDate.replace(/dd/g, day);
    formattedDate = formattedDate.replace(/HH/g, hours);
    formattedDate = formattedDate.replace(/mm/g, minutes);
    formattedDate = formattedDate.replace(/ss/g, seconds);

    return formattedDate;
}

// store
// https://medium.com/@art3330/simple-proxy-object-based-store-manager-for-react-9798b1407017
// https://github.com/barrypeng6/react-proxy-store
// https://www.google.com/search?q=ValtioJS&sca_esv=a8f3f333d99b26eb&sxsrf=ANbL-n5c2_MY-ceidzEfwIm25pwYtTy6iQ%3A1768313044450&ei=1FBmabeYG53R2roPksCwgAw&ved=2ahUKEwiT1ZGi2IiSAxXLk1YBHUq0JhoQgK4QegQIBRAD&uact=5&oq=react+store+with+proxy&gs_lp=Egxnd3Mtd2l6LXNlcnAiFnJlYWN0IHN0b3JlIHdpdGggcHJveHkyCBAhGKABGMMEMggQIRigARjDBDIIECEYoAEYwwRIrz1Q4RZYvjtwAngAkAEAmAGaAaAB0wuqAQQwLjExuAEDyAEA-AEB-AECmAILoALUCcICChAAGEcY1gQYsAPCAgYQABgIGB7CAggQABgIGB4YCsICBBAjGCfCAgYQABgHGB7CAgUQABiABMICCBAAGIAEGMsBwgIKEAAYCBgHGB4YCsICBRAAGO8FwgIKEAAYCBgeGA0YCsICChAhGAoYoAEYwwSYAwCIBgGQBgqSBwMyLjmgB6s5sgcDMC45uAfOCcIHBTAuOS4yyAcWgAgB&sclient=gws-wiz-serp&mstk=AUtExfB5uLkZcoG5BamrxmZN2HW5-f2OQ4wMVQIrjaxni91eejSruAx31E4OTR3nYkYYE2fDngcG66ubMyDhumZQ4sA4oqkKcuNw7Xn4YM1GRZL_6E_nMDT0exAmJMi3HiNcSaxalkcVpGIgxlAKEV1Kp6VYv-BPJ1NbmqsMfnNCYnIBFGsMnOXk2qnKB4WPKq4tS1X4eWbnViOtRd9oc8ByL5KUyRSK08Q8a_lduDZRjbOLOEPnN_0kyNqOeuUQWmX8i4Y49LujKNiLMMOhtG7jqzgNyIT6DvCq0eh4587ZcrppSg&csui=3
// https://www.google.com/search?q=make+react+store+with+js+proxy&sca_esv=a8f3f333d99b26eb&biw=1544&bih=820&aic=0&sxsrf=ANbL-n6iLbkZHJrF7_WUj4aKYhnvVi1y8Q%3A1768313381785&ei=JVJmacbCL-Xe2roPuOrV6QU&ved=0ahUKEwiG6ePX2IiSAxVlr1YBHTh1NV0Q4dUDCBE&uact=5&oq=make+react+store+with+js+proxy&gs_lp=Egxnd3Mtd2l6LXNlcnAiHm1ha2UgcmVhY3Qgc3RvcmUgd2l0aCBqcyBwcm94eTIIEAAYiQUYogQyBRAAGO8FMggQABiABBiiBDIFEAAY7wVIyi9QKVi1G3ABeAGQAQCYAbABoAHKB6oBAzAuNrgBA8gBAPgBAZgCBaACkQXCAgoQABhHGNYEGLADwgIIECEYoAEYwwTCAgoQIRgKGKABGMMEmAMAiAYBkAYKkgcDMS40oAeoDrIHAzAuNLgHjgXCBwMwLjXIBwiACAE&sclient=gws-wiz-serp
// https://gomakethings.com/simple-reactive-data-stores-with-vanilla-javascript-and-proxies/
// https://codesandbox.io/p/sandbox/proxy-react-store-gxktjm?file=%2Fsrc%2FApp.tsx%3A45%2C29-45%2C39

export function createStore<T extends object>( initialState: T ): Store<T> {
  const handlers: Array< ( state: T )=>void > = [];
  const proxy = new Proxy( initialState, {
    set( target, prop, value ) {
      target[ prop as keyof T ] = value;
      handlers.forEach( handler => handler( proxy ) );
      return true;
    }
  }); 
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ( proxy as any ).subscribe = ( handler: ( state: T )=>void )=>{
    handlers.push( handler );
    handler( proxy ); // initial call
    return ()=>{
      const index = handlers.indexOf( handler );
      if( index>=0 ) handlers.splice( index, 1 );
    } 
  };
  return proxy as Store<T>;
}
export type Store<T> = T & {
  subscribe: ( handler: ( state: T )=>void )=>()=>void
};  

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// export function isStore<T>( obj: any ): obj is Store<T> {
//   return typeof obj==='object' && obj!==null && typeof obj.subscribe==='function';
// }

export function useStore<T>( store: Store<T> ): T {
  /* 
  const [ state, setState ] = useState<T>( store );
  useEffect( ()=>{     
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const unsubscribe = store.subscribe( ( _newState: T )=>{
      // console.log(">>store subscribe:", _newState );
      // setState( { ..._newState } );
    } );
    return ()=>unsubscribe();
  }, [ store ] );
  return state;
  */

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, forceUpdate] = useReducer((x) => x + 1, 0);
  
  useEffect( ()=>{     
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const unsubscribe = store.subscribe( ( _newState: T )=>{
      // console.log(">>store subscribe:", _newState );
      // setState( { ..._newState } );
      forceUpdate();
    } );
    return ()=>unsubscribe();
  }, [ store ] );
  // return state;
  return store;
}

// usage:
// const myStore = createStore({ count:0 });
// function MyComponent(){  
//   const state = useStore( myStore );
//   return <div>{state.count}</div>
// }

